'use client';

import { Alert, Snackbar } from '@mui/material';
import React from 'react';
import { AnnouncementBanner } from '@peerless/data-access/strapi';
import { formatTextPosition } from '../utils';

interface Props {
  announcement: AnnouncementBanner;
  hideAnnouncementCookieAction: () => Promise<void>;
}

export function AnnouncementSnackbar({ announcement, hideAnnouncementCookieAction }: Props) {
  const { text, closeButtonAlignment, textAlignment } = announcement;
  const [open, setOpen] = React.useState(true);

  return (
    <Snackbar
      open={open}
      sx={{
        left: '0 !important',
        bottom: '0 !important',
        width: '100%',
        '& .MuiAlert-action': { alignItems: 'center', margin: '0 !important', padding: '0' },
        '& .MuiSvgIcon-root': { fontSize: '1rem' },
        '& .MuiPaper-root': { padding: 2 },
        display: 'block',
        textAlign: 'center',
        zIndex: '1200',
      }}
      ContentProps={{ sx: { textAlign: 'center' } }}
    >
      <Alert
        icon={false}
        onClose={() => {
          setOpen(false);
          hideAnnouncementCookieAction();
        }}
        severity="error"
        variant="filled"
        sx={{
          fontSize: '1.125rem',
          fontWeight: '400',
          justifyContent: 'start',
          display: 'flex',
          width: '100%',
          flexDirection: closeButtonAlignment === 'Left' ? 'row-reverse' : 'row',
          '& .MuiAlert-action': {
            marginLeft: closeButtonAlignment === 'Left' ? 'unset' : 'auto',
          },
          '& .MuiAlert-message': {
            textAlign: formatTextPosition(textAlignment),
            width: 'inherit',
            padding: '0 1rem',
          },
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: text }} />
      </Alert>
    </Snackbar>
  );
}
